module.exports = __webpack_public_path__ + "img/gonetwork0_2.cff1fce3.png";